// app/user/user.js

(function () {
    'use strict';
    var controllerId = 'user';
    angular.module('app').controller(controllerId, ['common', 'bootstrap.dialog', '$rootScope', '$scope', '$routeParams', '$uibModal', '$location', 'datacontext', 'sectionMenu', user]);

    function user(common, bDialog, $rootScope, $scope, $routeParams, $uibModal, $location, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this, onRouteChangeOff;
        vm.title = 'Utenti';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "User"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.risorsa = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;
        vm.addDisabled = !$rootScope.isAuthorized('SUPER') && !$rootScope.isAuthorized('PERSONALE');
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.super = $rootScope.isAuthorized('SUPER');

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['username', 'email', 'data attivazione desc'];
        vm.ordine = vm.list.ordine[2];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            vm.cerca();
        };

        vm.item = {};

        //Elenchi dettaglio
        vm.list.ruoli = [];
        vm.list.gruppoAmm = [];
        vm.list.gruppoDid = [];
        vm.ruoli = [];
        vm.list.aziende = [];
        vm.list.dipendenti = [];

        vm.getRecord = getRecord;
        vm.getListRuoli = getListRuoli;
        vm.deleteRuolo = deleteRuolo;
        vm.getRuoli = getRuoli;
        vm.addRuolo = addModalRole;

        //Filtro
        vm.filter = {};
        vm.filter.bAttivo = vm.fBAttivo = 1;
        vm.filter.username = vm.fUsername = '';
        vm.filter.email = vm.fEmail = '';
        vm.filter.ruolo = vm.fRuolo = '';

        vm.format = 'dd/MM/yyyy';

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.get = getRecord;
        vm.add = addModal;
        vm.addRole = addModalRole;
        vm.update = updateItem;
        vm.updatePassword = updatePassword;
        vm.activate = setActive;
        vm.deactivate = setDeactive;
        vm.resetPassword = resetPassword;
        vm.invioCredenziali = invioCredenziali;
        vm.delete = deleteItem;
        vm.selezionaDipendente = selezionaDipendente;
        vm.annullaDipendente = annullaDipendente;
        vm.confirmRoute = confirmRoute;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getRuoli(), getAziende()];
            common.activateController(promises, controllerId)
                .then(function () {
                    if ($routeParams.UserId != null) {
                        setView('detail');
                        getRecord($routeParams.UserId, 0);
                    }

                });
        }

        //****************************************************
        /*CONFIRM SAVE BEFORE CHANGE ROUTE */
        //****************************************************
        function init() {
            //initialize data here..    
            vm.item.editForm = false;

            //Make sure they"re warned if they made a change but didn"t save it
            //Call to $on returns a "deregistration" function that can be called to
            //remove the listener (see routeChange() for an example of using it)
            onRouteChangeOff = $scope.$on("$locationChangeStart", routeChange);
        }
        init();

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;

            if (!vm.filter.ruoloId) vm.filter.ruoloId = 0;
            if (!vm.filter.aziendaId) vm.filter.aziendaId = 0;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.super_user_countAll(vm.filter.ricerca, vm.filter.bAttivo, vm.filter.aziendaId, vm.filter.ruoloId).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.super_user_getAll(vm.pageSize, vm.page, vm.filter.ricerca, vm.filter.bAttivo, vm.filter.aziendaId, vm.filter.ruoloId, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    vm.records.push.apply(vm.records, data);
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.user_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;

                vm.record.DtAttivazione = common.dateToString(vm.record.DtAttivazione);

                //Azzera liste
                vm.list.ruoli = [];
                vm.record.Password = '';
                vm.confPassword = '';
                vm.strDipendente = '';

                //Ottengo tutti i dipendenti e il relativo nominativo
                getDipendenti();

                getListRuoli(vm.record.Id)

                setView('detail');
            });
        }

        function addRecord(id) {
            return datacontext.user_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function updateItem() {
            vm.record.DtAttivazione = common.stringToDate(vm.record.DtAttivazione);
            return datacontext.user_update(vm.record).then(function (data) {
                if (!data) {
                    if (vm.recordForm)
                        vm.recordForm.$setPristine();
                    vm.record.DtAttivazione = common.dateToString(vm.record.DtAttivazione);
                    logSuccess('Dato salvato');
                }
                else
                    logError('Impossibile salvare il dato');
            });
        }

        function updatePassword() {
            if (vm.record.Password != vm.confPassword) {
                logError('Le due password devono coincidere');
                return;
            }

            vm.record.DtAttivazione = common.stringToDate(vm.record.DtAttivazione);
            return datacontext.user_update(vm.record).then(function (data) {
                if (!data) {
                    vm.record.DtAttivazione = common.dateToString(vm.record.DtAttivazione);
                    logSuccess('Dato salvato');
                }
                else
                    logError('Impossibile salvare il dato');
            });
        }

        function confirmRoute(event, newUrl) {
            var attempt = true;

            if (vm.recordForm)
                vm.item.editForm = vm.recordForm.$dirty;

            if (vm.item.editForm) {
                bDialog.confirmationDialog('Modifiche non salvate', 'Sono presenti modifiche non salvate. Vuoi salvare le modifiche?', 'Salva modifiche e procedi', 'Annulla modifiche e procedi').then(function () { //YES
                    if (vm.recordForm.$valid) {
                        vm.update(vm.recordForm.$event);

                        vm.item.editForm = false;
                        onRouteChangeOff(); //Stop listening for location changes

                        if (newUrl == '') {
                            $location.url("/user");
                        }
                        else
                            $location.path($location.url(newUrl).hash()); //Go to page they're interested in                    

                        return attempt;
                    } else {
                        logError('Compilare i campi obbligatori');
                        return attempt;
                    }
                }, function (btn) { // NO
                    vm.item.editForm = false;
                    onRouteChangeOff(); //Stop listening for location changes

                    if (newUrl == '') {
                        $location.url("/user");
                    }
                    else
                        $location.path($location.url(newUrl).hash()); //Go to page they're interested in                    

                    vm.change = 0;
                    return attempt;
                });
            }
            else {
                attempt = false;
                vm.item.editForm = false;
                onRouteChangeOff(); //Stop listening for location changes
                if (newUrl == '') {
                    $location.url("/user");

                    vm.index = 0;
                }
                else
                    $location.path($location.url(newUrl).hash()); //Go to page they're interested in   
            }

            return attempt;
        }

        function routeChange(event, newUrl, oldUrl) {
            vm.change++;
            if (vm.change == 1) {
                if (confirmRoute(event, newUrl, vm.recordForm)) {
                    event.preventDefault();
                    return;
                }
            }
        }

        function setActive(id, index) {
            return datacontext.user_activate(id).then(function (data) {
                if (!data) {
                    vm.index = index;
                    vm.record = data;
                    logSuccess('Dato salvato');
                }
                else
                    logError('Impossibile salvare il dato');
            });
        }

        function setDeactive(id, index) {
            return datacontext.user_deactivate(id).then(function (data) {
                if (!data) {
                    vm.index = index;
                    vm.record = data;
                    logSuccess('Dato salvato');
                }
                else
                    logError('Impossibile salvare il dato');
            });
        }

        //Manda una email all'utente con un link di accesso al Reset Password
        //dove l'utente pu� inserire una nuova password per il suo account
        function resetPassword(item, index) {
            var msg = ' Inviare Email per il Reset della password all\'utente ' + item.Username;
            bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                function () { //YES
                    return datacontext.user_resetPassword(item.Email).then(function (data) {
                        console.log(data);
                        if (data != "204") return logError('Errore!!!');

                        logSuccess('Operazione effettuata con successo! ');
                        vm.index = index;
                    });
                },
                function () { //NO
                    //vm.record.Completed = false;
                });
        }

        function invioCredenziali(item, index) {
            var msg = ' Inviare Email con le Nuove Credenziali dell\'utente ' + item.Username;
            bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                function () { //YES
                    return datacontext.user_invioCredenziali(' ', item.Email).then(function (data) {
                        console.log(data);
                        if (data != "204") return logError('Impossibile eseguire l\'operazione');

                        logSuccess('Operazione effettuata con successo! ');
                        vm.index = index;
                    });
                },
                function () { //NO
                    //
                });
        }

        function deleteItem(item) {
            var msg = ' l\'utente ' + item.Username;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.user_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    var index = vm.records.indexOf(item)
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }

        //Elenchi dettagli
        function getAziende() {
            return datacontext.azienda_getAll(0, 0, '', '').then(function (data) {
                return vm.list.aziende = data;
            });
        }

        function getRuoli() {
            return datacontext.role_getAllList().then(function (data) {
                return vm.ruoli = data;
            });
        }

        function getListRuoli(id) {
            return datacontext.userRole_getAll(id).then(function (data) {
                return vm.list.ruoli = data;
            });
        }

        function deleteRuolo(item) {
            if (vm.list.ruoli.length == 1) {
                logError('L\'utente deve avere almeno un ruolo');
                return;
            }

            var msg = ' Ruolo ' + item.Etichetta + ' per l utente ' + vm.record.Username;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.userRole_delete(vm.record.Id, item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    var index = vm.list.ruoli.indexOf(item)
                    vm.list.ruoli.splice(index, 1);
                });
            });
        }

        //Dipendenti-list
        function getDipendenti() {
            return datacontext.azienda_get(vm.record.AziendaId).then(function (azienda) {
                return datacontext.dipendente_getAllByDB(azienda.DB).then(function (dip) {
                    vm.list.dipendenti = dip;

                    if (vm.record.DipendenteId && vm.record.DipendenteId != 0) {
                        var d = _.find(vm.list.dipendenti, { 'Id': vm.record.DipendenteId })
                        if (d) vm.strDipendente = d.Nominativo;
                    }

                    return vm.list.dipendenti;
                });
            });
        }

        // Selezione dipendente
        function selezionaDipendente() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/dipendenteSelectSuper.html?version=30',
                controller: 'dipendenteSelectSuper',
                windowClass: 'modal-wide',
                resolve: {
                    dipendenti: function () {
                        return vm.list.dipendenti;
                    }
                }
            });
            modalInstance.result.then(function (returnItem) {
                vm.record.DipendenteId = returnItem.id;
                vm.strDipendente = returnItem.nominativo;
                updateItem();
            });
        }

        function annullaDipendente() {
            vm.record.DipendenteId = 0;
            vm.strDipendente = '';
            updateItem();
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/user/modal/userAdd.html?version=30',
                controller: 'userAdd',
                resolve: {
                    ruoli: function () {
                        return vm.ruoli;
                    },
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la creazione del dato ');

                logSuccess('Record creato con successo ');
                addRecord(returnItem.Id);
                getListRuoli(returnItem.Id);
            });
        };

        function addModalRole() {
            var record = { Id: vm.record.Id, Name: vm.record.Username };

            //Ruolo
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/user/modal/userRoleAdd.html?version=30',
                controller: 'userRoleAdd',
                resolve: {
                    risorse: function () {
                        return [record];
                    },
                    risorsaId: function () {
                        return vm.record.Id;
                    },
                    ruoli: function () {
                        return vm.ruoli;
                    },
                    ruoloId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la creazione del dato ');

                logSuccess('Record creato con successo ');
                getListRuoli(vm.record.Id);
            });
        };
    }
})();
